import { useContext } from 'react';
import AnchorButton from '@/common/AnchorButton';
import { TitleWrap, Title, Text } from '@/vdp/AlertModal';
import ModalContext from '~/context/vdp/ModalContext';
import { useDDAddAction } from '~/hooks/common/telemetry';
import AlertIcon from './AlertIcon';

const TemporaryOutOfMarket = () => {
  useDDAddAction('Temporary Out Of Market - Banner Shown');
  const { setGeolocationModalOpen } = useContext(ModalContext);

  return (
    <>
      <TitleWrap>
        <AlertIcon />
        <Title>Out Of Market</Title>
      </TitleWrap>
      <Text>
        Unfortunately, Carvana delivery to this location is temporarily
        unavailable. We plan for Carvana’s haulers to deliver the car to your
        home soon. Please come back shortly or{' '}
        <AnchorButton
          data-analytics-id="Alert Modal - Temporary Out of Market Change Location"
          onClick={() => setGeolocationModalOpen(true)}
        >
          change location
        </AnchorButton>
      </Text>
    </>
  );
};

export default TemporaryOutOfMarket;
